import React, { useEffect, useState } from 'react'
import { View, Text, TouchableOpacity, ImageBackground, FlatList, StyleSheet, Platform, Dimensions, useWindowDimensions } from 'react-native'
import { useNavigation } from '../../hooks/useWebNavigation'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { apiUrl } from '../../config/config'
import NetInfo from '@react-native-community/netinfo'
import Styles from './PortfolioSubcategoryStyles'
import theme from '../../../theme'
import { CatalogueCategoriesModel, SingleCatalogueModel } from './models/PortfolioModel'
import { TrackingServices } from '../../../database/tracking.database'
import { getLanguage } from '../appBar/context/LocalizationContext'
import Constants from 'expo-constants'
import { FlashList } from '@shopify/flash-list'
import { useBreakpoint } from '@/redux/zustand/useDimensionStore'

// const { width } = Dimensions.get('window')

export const PortfolioSubcategory = ({ route }) => {
    const { width, height } = useWindowDimensions()
    const [categorysArray, setCates] = useState<CatalogueCategoriesModel[]>([])
    const { id, categories, isBrand } = route.params
    const navigation = useNavigation()

    const goToSubCategory = (data: CatalogueCategoriesModel) => {
        console.log('[PortfolioSubcategory][goToSubCategory] data:', data)
        console.log('[PortfolioSubcategory][goToSubCategory] categories:', data.categories?.length, 'products:', data.products?.length)
        TrackingServices.addTracking(data._id, 'ecommerce_categories', 'ecommerce_categories')
        console.log('DATA CATEGORIES: ', JSON.stringify(data))
        if (data.categories && Array.isArray(data.categories) && data.categories.length > 0) {
            console.log('[PortfolioSubcategory] Navegando a SubCategory con', data.categories.length, 'categorías')
            // En web usamos navigate en lugar de push
            navigation.navigate('SubCategory', { id: data._id, categories: data.categories, isBrand: false })
        } else {
            console.log('[PortfolioSubcategory] Navegando a PortfolioProducts con', data.products?.length || 0, 'productos')
            navigation.navigate('PortfolioProducts', { categoryId: data._id, products: data.products, item: data })
        }
    }
    useEffect(() => {
        getData()
    }, [route])

    const getData = async () => {
        try {
            setCates(route.params.categories)
            console.log('CATEGORIAS SETEADAS ==> ', JSON.stringify(route.params.categories))
        } catch (error) {
            console.error('Error obteniendo las cats:', error.message, error.stack)
        }
    }
    return <Subcategory subcategorys={categorysArray} goToSubCategory={goToSubCategory} />
}

export const Subcategory = ({
    subcategorys,
    goToSubCategory,
}: {
    subcategorys: CatalogueCategoriesModel[]
    goToSubCategory: (data: CatalogueCategoriesModel) => void
}) => {
    // Update the type annotation
    // console.log('109 ------------ Categorias en la vista Subcategory', subcategorys)
    const { width, height } = useWindowDimensions()

    const { languageFile } = getLanguage()
    const isWeb = Platform.OS === 'web'
    const expoConfig: { slug?: string } = (Constants as any).expoConfig || {}
    const breakPoint = useBreakpoint()
    const isMobile = breakPoint === 'sm'
    // Para web: calcular número de columnas basado en ancho de pantalla
    const numColumns = isWeb ? (width > 1200 ? 3 : width > 768 ? 2 : 1) : 1

    return (
        <View style={Styles.container}>
            <View style={Styles.portfolioHeader}>
                {expoConfig.slug != 'branca-one' ? (
                    <Text style={Styles.titleSection}>{languageFile.portfolio}</Text>
                ) : (
                    <Text style={[Styles.titleSection, !isMobile && { fontSize: 22 }]}>{'Catálogo'}</Text>
                )}
                {expoConfig.slug != 'branca-one' ? (
                    <Text style={Styles.descriptionSection}>{languageFile.learn_about}</Text>
                ) : (
                    <Text style={[Styles.descriptionSection, !isMobile && { fontSize: 20 }]}>{'Conocé nuestra amplia gama de productos.'}</Text>
                )}
            </View>
            <View style={Styles.spacer}></View>
            <FlatList
                data={subcategorys?.filter((sub) => sub !== null).sort((a, b) => a.index_category - b.index_category)} // TODO: fixear que la base de datos local no guarde nulls
                keyExtractor={(item) => item?._id}
                horizontal={false}
                showsVerticalScrollIndicator={false}
                numColumns={numColumns}
                key={`grid-${numColumns}`}
                {...(numColumns > 1 && {
                    columnWrapperStyle: {
                        gap: 8, // Espacio horizontal entre columnas
                    },
                })}
                ItemSeparatorComponent={() => <View style={{ height: 8 }} />} // Espacio vertical entre filas
                renderItem={({ item: item }) => (
                    <SubCategoryItem item={item} goToSubCategory={goToSubCategory} numColumns={numColumns} key={item._id} />
                )}
            />
        </View>
    )
}
export const SubCategoryItem = ({
    item,
    goToSubCategory,
    numColumns = 1,
}: {
    item: CatalogueCategoriesModel
    goToSubCategory: (data: CatalogueCategoriesModel) => void
    numColumns?: number
}) => {
    const [category, setCategory] = useState({
        image: item?.image,
        name: item?.name,
        description_short: item?.description_short,
    })
    const expoConfig: { slug?: string } = (Constants as any).expoConfig || {}
    const isWeb = Platform.OS === 'web'

    const maxWidth = numColumns > 2 ? '33%' : '50%'
    return (
        <TouchableOpacity style={[Styles.categoryContainer, numColumns > 1 && { maxWidth: maxWidth }]} onPress={() => goToSubCategory(item)}>
            {category.image && category.image !== '' ? (
                <ImageBackground style={Styles.categoryContainerImageBackground} source={{ uri: category.image }}>
                    {category.name &&
                        expoConfig.slug != 'danone-one' &&
                        expoConfig.slug != 'mars-betthertogether' &&
                        expoConfig.slug != 'savencia-one' &&
                        expoConfig.slug != 'shell-somosprotagonistas' &&
                        expoConfig.slug != 'dots-ii' && <Text style={Styles.titleCategory}>{category.name.toUpperCase()}</Text>}
                    {category.description_short &&
                        expoConfig.slug != 'danone-one' &&
                        expoConfig.slug != 'mars-betthertogether' &&
                        expoConfig.slug != 'savencia-one' &&
                        expoConfig.slug != 'beiersdorf-wts' &&
                        expoConfig.slug != 'dots-ii' &&
                        expoConfig.slug != 'shell-somosprotagonistas' && (
                            <Text style={Styles.descriptionCategory}>{category.description_short.toUpperCase()}</Text>
                        )}
                </ImageBackground>
            ) : (
                <View style={Styles.categoryContainerColorBackground}>
                    {category.name && <Text style={Styles.titleCategory}>{category.name.toUpperCase()}</Text>}
                    {category.description_short && <Text style={Styles.descriptionCategory}>{category.description_short.toUpperCase()}</Text>}
                </View>
            )}
        </TouchableOpacity>
    )
}

// Estilos específicos para web
const webStyles = StyleSheet.create({
    gridRow: {
        justifyContent: 'flex-start',
    },
    gridItem: {
        flex: 1,
        margin: 0,
        padding: 0,
        aspectRatio: 16 / 9, // Aspect ratio 16:9
        height: undefined, // Dejar que aspectRatio controle la altura
    },
})
